import { CKButton, CKModal } from '@clearkit/react';

const SaveFieldMappingModal = ({
  confirmSaveDialogOpen,
  setConfirmSaveDialogOpen,
  objectTypeFormating,
  readableType,
  integration,
  triggering,
  isUpdating,
  updateFieldMapping,
  input,
}) => {
  return (
    <CKModal
      baseId="toggle-field-mapping-modal"
      visible={confirmSaveDialogOpen}
      hide={() => setConfirmSaveDialogOpen(false)}
      size="md"
      aria-label="Modal">
      <CKModal.Header>
        <CKModal.Heading>
          Would you like to backfill all {objectTypeFormating()} with this
          mapping?
        </CKModal.Heading>
      </CKModal.Header>
      <CKModal.Body className="px-10 py-6">
        <p>
          Without a backfill, you may see inconsistencies in reporting and data
          synced to {objectTypeFormating()} in {readableType(integration)}
        </p>
      </CKModal.Body>
      <CKModal.Footer className="gap-2">
        <CKButton
          isLoading={triggering || isUpdating}
          onClick={async () => {
            await updateFieldMapping();
            setConfirmSaveDialogOpen(false);
          }}>
          No, thanks
        </CKButton>
        <CKButton
          variant={CKButton.Variant.bold}
          variantColor="blue"
          isLoading={triggering || isUpdating}
          onClick={async () => {
            await updateFieldMapping({
              variables: { input: { ...input, backfill: true } },
            });
            setConfirmSaveDialogOpen(false);
          }}>
          Start backfill
        </CKButton>
      </CKModal.Footer>
    </CKModal>
  );
};

export default SaveFieldMappingModal;
